
const QuotDown=()=>{

    return(
        <svg t="1665324176155" class="icon" viewBox="0 0 1024 1024" version="1.1"
         xmlns="http://www.w3.org/2000/svg" p-id="2119" width="20" height="20">
            <path d="M518.4 819.2c0-12.8 12.8-25.6 44.8-44.8 153.6-108.8 224-204.8 224-275.2 0-38.4-25.6-70.4-70.4-83.2-70.4-25.6-96-70.4-96-115.2 0-38.4 19.2-134.4 134.4-134.4 89.6 0 204.8 64 204.8 217.6 0 160-147.2 326.4-352 473.6-12.8 12.8-25.6 12.8-32 12.8-12.8 0-25.6-6.4-38.4-19.2C524.8 832 518.4 825.6 518.4 819.2zM64 819.2c0-12.8 12.8-25.6 44.8-44.8 153.6-108.8 224-204.8 224-275.2 0-38.4-25.6-70.4-70.4-83.2C198.4 390.4 166.4 345.6 166.4 294.4c0-38.4 19.2-134.4 134.4-134.4 89.6 0 204.8 64 204.8 217.6 0 160-147.2 326.4-352 473.6-12.8 12.8-25.6 12.8-38.4 12.8C96 864 64 832 64 819.2z" p-id="2120" fill="#cdcdcd"></path></svg>
       
        )
}

export default QuotDown;